import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, api } from "@/App";
import { Button } from "@/components/ui/button";
import { X, VenetianMask } from "lucide-react";
import { useLocale } from "@/i18n/LocaleContext";

export default function SecretAdmirerPromo() {
  const { t } = useLocale();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("sa_promo_dismissed") === "1");
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (dismissed || !user || (user.credits || 0) < 50) return;
    Promise.all([api.get("/social-invites/mine"), api.get("/companions")])
      .then(([inv, comp]) => {
        if ((inv.data.invites || []).length > 0) return;
        const comps = comp.data.companions || [];
        const pick = user.gender === "female"
          ? comps.find((c) => c.ai_persona === "mr_luxe")
          : comps.find((c) => c.ai_persona === "ms_luxe");
        setTarget(pick || comps[0] || null);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissed, user?.user_id]);

  if (dismissed || !target || (user?.credits || 0) < 50) return null;

  return (
    <div className="relative mb-6 p-4 rounded-2xl border border-pink-500/30 bg-gradient-to-r from-pink-500/10 to-violet-500/10" data-testid="sa-promo-card">
      <button
        onClick={() => { localStorage.setItem("sa_promo_dismissed", "1"); setDismissed(true); }}
        className="absolute top-2.5 right-2.5 text-muted-foreground hover:text-white"
        data-testid="sa-promo-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <p className="font-semibold flex items-center gap-2 mb-1">
        <VenetianMask className="w-4 h-4 text-pink-400" /> {t("saPromo.title")}
      </p>
      <p className="text-sm text-muted-foreground mb-3">{t("saPromo.body", { n: user.credits })}</p>
      <Button
        size="sm"
        className="bg-pink-600 hover:bg-pink-500 text-white"
        onClick={() => navigate(`/profile/${target.user_id}`)}
        data-testid="sa-promo-cta"
      >
        {t("saPromo.cta")}
      </Button>
    </div>
  );
}
